<template>
  <card title="Vertical Space" :element="element">
    <e-name :element="element"></e-name>
    <e-space :element='element'</e-space>
    <e-space class='mt-4' :element="element"></e-space>
  </card>
</template>

<script>
// import Component from "../component_location"
import CSlider from "@/components/Core/CSlider.vue";
import Card from "./Card.vue";
import EName from "./EName.vue";
import ESpace from "./ESpace.vue";
import ETransition from "./ETransition";

export default {
  components: {
    CSlider,
    Card,
    EName,
    ESpace,
  },

  props: {
    element: {
      type: Object,
      default: () => {
        return {name:''};
      },
    },
  },

  data() {
    return {
      open: true,
    };
  },

  watch: {},

  methods: {
    toggle() {
      this.open = !this.open;
    },
  },

  computed: {},

  mounted() {},

};
</script>

<style></style>

